import React, {
  FunctionComponent,
} from 'react';
import {
  MenuList, MenuItem,
} from '@material-ui/core';
import { SubMenuProps } from './sub-menu.props';
import { CascadingMenuItem } from '../cascading-menu-item';

export const SubMenuItem: FunctionComponent<SubMenuProps> = (props) => {
  const options = props.items;

  const passSelectedOption = (event: React.MouseEvent<EventTarget>, item: CascadingMenuItem) => {
    props.optionSelected(event, item);
  };

  return (
    <MenuList className="subMenu__option--mobile">
      {options.map((option, j) => (
        <MenuItem
          id={option.id}
          key={option.id}
          onClick={(e) => passSelectedOption(e, option)}
          className={props.styleClass(option)}
        >
          {option.label}
        </MenuItem>
      ))}
    </MenuList>
  );
};
